export const documentButtonStyle = {
    minWidth: 120,
    borderRadius: "12px",
    padding: "6px 14px",
    background: "#284CB133",
    color: "#1E1E1E",
    fontSize: "12px",
    fontWeight: 700,
  };